<template>
  <div class="flex-1 mt-1 bg-gray-100 px-4 pt-12 shadow-lg items-center">
    <!--  -->
    <div class="bg-white w-full rounded-lg shadow">
      <!--  -->
      <div class="h-20 py-3 flex items-center border-gray-200 p-6 mt-2">
        <!--  -->
        <div class="flex">
          <!--  -->
          <button :class="$colors.primary" class="rounded-full flex justify-center items-center w-8 h-8 mr-3" @click="RouterBack()">
            <!--  -->
            <i class="material-icons">chevron_left</i>
            <!--  -->
          </button>
          <!--  -->

          <!--  -->
          <div v-if="!formData._id" class="text-2xl font-bold text-orange-500">
            <!--  -->
            New Team
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div v-else class="text-2xl font-bold text-orange-500">Edit team</div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <div class="">
        <!--  -->
        <div class="bg-white rounded-lg p-6 pt-2">
          <!--  -->
          <div class="grid lg:grid-cols-2 gap-6">
            <!--  -->
            <div class="border hover:border-orange-400 focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="name" class="bg-white text-gray-700 px-1">
                    <!--  -->
                    Name <span :class="$colors.required">*</span>
                    <!--  -->
                  </label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <p>
                <!--  -->
                <input id="name" autocomplete="false" tabindex="0" type="text" v-model="formData.name" class="py-2 text-xs px-2 outline-none block h-full w-full" />
                <!--  -->
              </p>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div class="border hover:border-orange-400 focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="description" class="bg-white text-gray-700 px-1">Description</label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <p>
                <!--  -->
                <input id="description" autocomplete="false" tabindex="0" type="text" v-model="formData.description" class="py-2 text-xs px-2 outline-none block h-full w-full" />
                <!--  -->
              </p>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div class="border hover:border-orange-500  w-full focus-within:border-orange-500 focus-within:text-orange-500  transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="customerPhone" class="bg-white text-gray-700 px-1">Country ({{ $t('warehouse') }})
                    <!--  -->
                    <span :class="$colors.required">*</span></label>
                    <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <p>
                <!--  -->
                <v-select @input="setSelectedCountry" v-model="formData.country" :options="warehouses" label="name">
                  <!--  -->
                  <template slot="option" slot-scope="option">
                    <!--  -->
                    <img class="flag-img" :src="$f.getCountryCode(option.code)" />
                    <!--  -->
                    {{ option.name }}
                    <!--  -->
                  </template>
                  <!--  -->
                </v-select>
                <!--  -->
              </p>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div class="border hover:border-orange-400 w-full focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="customerPhone" class="bg-white text-gray-700 px-1">{{ 'his_orders' |t }}</label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <p class="flex items-center justify-center w-full">
                <!--  -->
                <label for="toogle3" class="cursor-pointer py-1">
                  <!--  -->
                  <div class="relative">
                    <!--  -->
                    <input id="toogle3" v-model="formData.hisOrders" type="checkbox" class="hidden" />
                    <!--  -->

                    <!--  -->
                    <div class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner" />
                    <!--  -->

                    <!--  -->
                    <div class="toggle__dot-3 absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0" />
                    <!--  -->
                  </div>
                  <!--  -->
                </label>
                <!--  -->
              </p>
              <!--  -->
            </div>
            <!--  -->

             <!--  -->
             <div class="border hover:border-orange-400 w-full focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="customerPhone" class="bg-white text-gray-700 px-1">{{ 'Trait by others post' |t }}</label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <p class="flex items-center justify-center w-full">
                <!--  -->
                <label for="toogle4" class="cursor-pointer py-1">
                  <!--  -->
                  <div class="relative">
                    <!--  -->
                    <input id="toogle4" v-model="formData.traitByOther" type="checkbox" class="hidden" />
                    <!--  -->

                    <!--  -->
                    <div class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner" />
                    <!--  -->

                    <!--  -->
                    <div class="toggle__dot-3 absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0" />
                    <!--  -->
                  </div>
                  <!--  -->
                </label>
                <!--  -->
              </p>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div>
            <!-- Select TeleConsultant -->
            <div v-if="formData.country" class="w-full">
              <!--  -->
              <div class="flex w-full space-x-6 h-full overflow-hidden">
                <!--  -->
                <div class="border mt-8 w-1/2 hover:border-orange-400 focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1">
                  <!--  -->
                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                    <!--  -->
                    <p>
                      <!--  -->
                      <label for="name" class="bg-white text-gray-700 px-1">
                        <!--  -->
                        Add TeleConsultant to group
                        <!--  -->
                        <span :class="$colors.required"> *</span>
                        <!--  -->
                      </label>
                      <!--  -->
                    </p>
                    <!--  -->
                  </div>
                  <!--  -->

                  <div class="md:w-full flex flex-col items-center p-1">
                    <!--  -->
                    <div class="w-full">
                      <!--  -->
                      <div class="flex flex-col items-center relative">
                        <!--  -->
                        <div class="w-full">
                          <!--  -->
                          <div class="mt-2 p-1 bg-white flex border border-gray-200 rounded">
                            <!--  -->
                            <div class="flex flex-auto flex-wrap"></div>
                            <!--  -->

                            <!--  -->
                            <input @input="searchSellersOrTeleCon($event, 'TeleConsultant')" v-model="searchTextTeleConsultant" placeholder="Search TeleConsultants" class="p-1 px-2 appearance-none outline-none w-full text-gray-800" />
                            <!--  -->

                            <!--  -->
                            <div class="text-gray-300 w-8 py-1 pl-2 pr-1 border-l flex items-center border-gray-200">
                              <!--  -->
                              <button class="cursor-pointer w-6 h-6 text-orange-500 outline-none focus:outline-none">
                                <!--  -->
                                <i class="material-icons">search</i>
                                <!--  -->
                              </button>
                              <!--  -->
                            </div>
                            <!--  -->
                          </div>
                          <!--  -->
                        </div>
                        <!--  -->

                        <!--  -->
                        <div class="bg-white mt-4 mb-2 max-h-select top-100 z-40 w-full rounded overflow-y-auto h-full">
                          <!--  -->
                          <div v-for="(user, index) in teleConsultants" :key="index" :value="user._id" class="flex flex-col w-full">
                            <!--  -->
                            <div class="cursor-pointer bg-gray-100 dark:bg-dark-1 border-b border-gray-200 dark:border-dark-1 w-full  rounded-t hover:bg-teal-100">
                              <!--  -->
                              <div class="flex w-full items-center p-2 pl-2 relative hover:border-teal-100">
                                <!--  -->
                                <div class="w-6 flex flex-col items-center">
                                  <!--  -->
                                  <div class="flex relative w-5 h-5 justify-center items-center m-1 mr-2">
                                    <!--  -->
                                    <i class="material-icons mx-2">account_circle</i>
                                    <!--  -->
                                  </div>
                                  <!--  -->
                                </div>
                                <!--  -->

                                <!--  -->
                                <div class="w-full items-center flex">
                                  <!--  -->
                                  <div class="mx-2 mt-2">
                                    <!--  -->
                                    {{ user.fullName }}
                                    <!--  -->
                                    <div class="text-xs truncate w-full normal-case font-normal -mt-1 text-gray-500">
                                      <!--  -->
                                      {{ user.email }}
                                      <!--  -->
                                    </div>
                                    <!--  -->
                                  </div>
                                  <!--  -->
                                </div>
                                <!--  -->

                                <!--  -->
                                <div class="w-full items-center flex">
                                  <!--  -->
                                  <div class="text-sm text-center leading-5 text-orange-500 bg-orange-100 px-4 font-semibold rounded-full text-gray-900">
                                    <!--  -->
                                    {{ user.type }}
                                    <!--  -->
                                  </div>
                                  <!--  -->
                                </div>
                                <!--  -->

                                <!--  -->
                                <div class="w-6 flex flex-col items-center">
                                  <!--  -->
                                  <button class="cursor-pointer w-6 h-6 text-black-500 outline-none focus:outline-none" @click="addItem('teleConsultants', index)">
                                    <!--  -->
                                    <i class="material-icons">add</i>
                                    <!--  -->
                                  </button>
                                  <!--  -->
                                </div>
                                <!--  -->
                              </div>
                              <!--  -->
                            </div>
                            <!--  -->
                          </div>
                          <!--  -->
                        </div>
                        <!--  -->
                      </div>
                      <!--  -->
                    </div>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->

                <!-- Selected Tele Consultant -->
                <div class="border mt-8 w-1/2 h-select hover:border-orange-400 focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1">
                  <!--  -->
                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                    <!--  -->
                    <p>
                      <!--  -->
                      <label for="name" class="bg-white text-gray-700 px-1">
                        <!--  -->
                        Selected TeleConsultant
                        <!--  -->
                        <span :class="$colors.required"></span>
                        <!--  -->
                      </label>
                      <!--  -->
                    </p>
                    <!--  -->
                  </div>
                  <!--  -->

                  <!--  -->
                  <div class="md:w-full flex flex-col items-center h-64">
                    <!--  -->
                    <div class="flex items-center justify-center py-2" v-if="formData.teleConsultants.length <= 0">
                      <!--  -->
                      <span class="w-full flex justify-center text-center py-20 border-gray-200 text-base">
                        <!--  -->
                        <p class="font-semibold flex text-orange-500 whitespace-no-wrap">
                          <!--  -->
                          <span class="">No TeleConsultant selected </span>
                          <!--  -->
                        </p>
                        <!--  -->
                      </span>
                      <!--  -->
                    </div>
                    <!--  -->

                    <!--  -->
                    <div class="w-full">
                      <!--  -->
                      <div class="flex flex-col items-center relative">
                        <!--  -->
                        <div class="absolute my-2 bg-white top-100 z-40 w-full lef-0 rounded min-h-select overflow-y-auto svelte-5uyqqj">
                          <!--  -->
                          <div v-for="(user, index) in formData.teleConsultants" :key="index" :value="user._id" class="flex flex-col w-full">
                            <!--  -->
                            <div class="cursor-pointer bg-gray-100 dark:bg-dark-1 border-b border-gray-200 dark:border-dark-1 w-full rounded-t hover:bg-teal-100">
                              <!--  -->
                              <div class="flex w-full items-center p-2 pl-2 relative hover:border-teal-100">
                                <!--  -->
                                <div class="w-6 flex flex-col items-center">
                                  <!--  -->
                                  <div class="flex relative w-5 h-5 0 justify-center items-center m-1 mr-2 mt-1 rounded-full">
                                    <!--  -->
                                    <div class="w-6 flex flex-col items-center">
                                      <!--  -->
                                      <div class="flex relative w-5 h-5 justify-center items-center m-1 mr-2">
                                        <!--  -->
                                        <i class="material-icons mx-2">account_circle</i>
                                        <!--  -->
                                      </div>
                                      <!--  -->
                                    </div>
                                    <!--  -->
                                  </div>
                                  <!--  -->
                                </div>
                                <!--  -->

                                <!--  -->
                                <div class="w-full items-center flex">
                                  <!--  -->
                                  <div class="mx-2 -mt-1">
                                    <!--  -->
                                    {{ user.fullName }}
                                    <!--  -->
                                    <div class="text-xs truncate w-full normal-case font-normal -mt-1 text-gray-500">
                                      <!--  -->
                                      {{ user.email }}
                                      <!--  -->
                                    </div>
                                    <!--  -->
                                  </div>
                                  <!--  -->
                                </div>
                                <!--  -->

                                <!--  -->
                                <div class="w-full items-center flex">
                                  <!--  -->
                                  <div class="text-sm text-center leading-5 text-orange-500 bg-orange-100 px-4 font-semibold rounded-full">
                                    <!--  -->
                                    {{ user.type }}
                                    <!--  -->
                                  </div>
                                  <!--  -->
                                </div>
                                <!--  -->

                                <!--  -->
                                <div class="w-6 flex flex-col items-center">
                                  <!--  -->
                                  <button class="cursor-pointer w-6 h-6 text-black-500 outline-none focus:outline-none" @click="deleteItem('teleConsultants', index)">
                                    <!--  -->
                                    <i class="material-icons">delete</i>
                                    <!--  -->
                                  </button>
                                  <!--  -->
                                </div>
                                <!--  -->
                              </div>
                              <!--  -->
                            </div>
                            <!--  -->
                          </div>
                          <!--  -->
                        </div>
                        <!--  -->
                      </div>
                      <!--  -->
                    </div>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->

            <!-- Select Sellers -->
            <div v-if="formData.country" class="w-full">
              <!--  -->
              <div class="flex w-full space-x-6 h-full overflow-hidden">
                <!--  -->
                <div class="border mt-8 w-1/2 hover:border-orange-400 focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1">
                  <!--  -->
                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                    <!--  -->
                    <p>
                      <!--  -->
                      <label for="name" class="bg-white text-gray-700 px-1">
                        <!--  -->
                        Add Sellers to group
                        <!--  -->
                        <span :class="$colors.required"> *</span>
                        <!--  -->
                      </label>
                      <!--  -->
                    </p>
                    <!--  -->
                  </div>
                  <!--  -->

                  <!--  -->
                  <div class="md:w-full flex flex-col items-center p-1">
                    <!--  -->
                    <div class="w-full">
                      <!--  -->
                      <div class="flex flex-col items-center relative">
                        <!--  -->
                        <div class="w-full">
                          <!--  -->
                          <div class="mt-2 p-1 bg-white flex border border-gray-200 rounded">
                            <!--  -->
                            <div class="flex flex-auto flex-wrap"></div>
                            <!--  -->

                            <!--  -->
                            <input @input="searchSellersOrTeleCon($event, 'Seller')" v-model="searchTextSeller" placeholder="Search Sellers" class="p-1 px-2 appearance-none outline-none w-full text-gray-800" />
                            <!--  -->

                            <!--  -->
                            <div class="text-gray-300 w-8 py-1 pl-2 pr-1 border-l flex items-center border-gray-200">
                              <!--  -->
                              <button class="cursor-pointer w-6 h-6 text-orange-500 outline-none focus:outline-none">
                                <!--  -->
                                <i class="material-icons">search</i>
                                <!--  -->
                              </button>
                              <!--  -->
                            </div>
                            <!--  -->
                          </div>
                          <!--  -->
                        </div>
                        <!--  -->

                        <!--  -->
                        <div class="bg-white mt-4 mb-2 max-h-select top-100 z-40 w-full rounded overflow-y-auto h-full">
                          <!--  -->
                          <div v-for="(user, index) in sellers" :key="index" :value="user._id" class="flex flex-col w-full">
                            <!--  -->
                            <div class="cursor-pointer bg-gray-100 dark:bg-dark-1 border-b border-gray-200 dark:border-dark-1 w-full  rounded-t hover:bg-teal-100">
                              <!--  -->
                              <div class="flex w-full items-center p-2 pl-2   relative hover:border-teal-100">
                                <!--  -->
                                <div class="w-6 flex flex-col items-center">
                                  <!--  -->
                                  <div class="flex relative w-5 h-5 justify-center items-center m-1 mr-2">
                                    <!--  -->
                                    <i class="material-icons mx-2">person</i>
                                    <!--  -->
                                  </div>
                                  <!--  -->
                                </div>
                                <!--  -->

                                <!--  -->
                                <div class="w-full items-center flex">
                                  <!--  -->
                                  <div class="mx-2 mt-2">
                                    <!--  -->
                                    {{ user.fullName }}
                                    <!--  -->
                                    <div class="text-xs truncate w-full normal-case font-normal -mt-1 text-gray-500">
                                      <!--  -->
                                      {{ user.email }}
                                      <!--  -->
                                    </div>
                                    <!--  -->
                                  </div>
                                  <!--  -->
                                </div>
                                <!--  -->

                                <!--  -->
                                <div class="w-full items-center flex">
                                  <!--  -->
                                  <div class="text-sm text-center leading-5 text-orange-500 bg-orange-100 px-4 font-semibold rounded-full">
                                    <!--  -->
                                    {{ user.type }}
                                    <!--  -->
                                  </div>
                                  <!--  -->
                                </div>
                                <!--  -->

                                <!--  -->
                                <div class="w-6 flex flex-col items-center">
                                  <!--  -->
                                  <button class="cursor-pointer w-6 h-6 text-black-500 outline-none focus:outline-none" @click="addItem('sellers', index)">
                                    <!--  -->
                                    <i class="material-icons">add</i>
                                    <!--  -->
                                  </button>
                                  <!--  -->
                                </div>
                                <!--  -->
                              </div>
                              <!--  -->
                            </div>
                            <!--  -->
                          </div>
                          <!--  -->
                        </div>
                        <!--  -->
                      </div>
                      <!--  -->
                    </div>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->

                <!-- Selected Sellers -->
                <div class="border mt-8 w-1/2 h-select hover:border-orange-400 focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1">
                  <!--  -->
                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                    <!--  -->
                    <p>
                      <!--  -->
                      <label for="name" class="bg-white text-gray-700 px-1">
                        <!--  -->
                        Selected Sellers
                        <!--  -->
                        <span :class="$colors.required"></span>
                        <!--  -->
                      </label>
                      <!--  -->
                    </p>
                    <!--  -->
                  </div>
                  <!--  -->

                  <!--  -->
                  <div class="md:w-full flex flex-col items-center h-64">
                    <!--  -->
                    <div class="flex items-center justify-center py-2" v-if="formData.sellers.length <= 0">
                      <!--  -->
                      <span class="w-full flex justify-center text-center py-20 border-gray-200 text-base">
                        <!--  -->
                        <p class="font-semibold flex text-orange-500 whitespace-no-wrap">
                          <!--  -->
                          <span class="">No seller selected </span>
                          <!--  -->
                        </p>
                        <!--  -->
                      </span>
                      <!--  -->
                    </div>
                    <!--  -->

                    <!--  -->
                    <div class="w-full">
                      <!--  -->
                      <div class="flex flex-col items-center relative">
                        <!--  -->
                        <div class="absolute my-2 bg-white top-100 z-40 w-full lef-0 rounded min-h-select overflow-y-auto svelte-5uyqqj">
                          <!--  -->
                          <div v-for="(user, index) in formData.sellers" :key="index" :value="user._id" class="flex flex-col w-full">
                            <!--  -->
                            <div class="cursor-pointer bg-gray-100 dark:bg-dark-1 border-b border-gray-200 dark:border-dark-1 w-full  rounded-t  hover:bg-teal-100">
                              <!--  -->
                              <div class="flex w-full items-center p-2 pl-2  relative hover:border-teal-100">
                                <!--  -->
                                <div class="w-6 flex flex-col items-center">
                                  <!--  -->
                                  <div class="flex relative w-5 h-5 0 justify-center items-center m-1 mr-2 mt-1 rounded-full">
                                    <!--  -->
                                    <div class="w-6 flex flex-col items-center">
                                      <!--  -->
                                      <div class="flex relative w-5 h-5 justify-center items-center m-1 mr-2">
                                        <!--  -->
                                        <i class="material-icons mx-2">person</i>
                                        <!--  -->
                                      </div>
                                      <!--  -->
                                    </div>
                                    <!--  -->
                                  </div>
                                  <!--  -->
                                </div>
                                <!--  -->

                                <!--  -->
                                <div class="w-full items-center flex">
                                  <!--  -->
                                  <div class="mx-2 -mt-1">
                                    <!--  -->
                                    {{ user.fullName }}
                                    <!--  -->
                                    <div class="text-xs truncate w-full normal-case font-normal -mt-1 text-gray-500">
                                      <!--  -->
                                      {{ user.email }}
                                      <!--  -->
                                    </div>
                                    <!--  -->
                                  </div>
                                  <!--  -->
                                </div>
                                <!--  -->

                                <!--  -->
                                <div class="w-full items-center flex">
                                  <!--  -->
                                  <div class="text-sm text-center leading-5 text-orange-500 bg-orange-100 px-4 font-semibold rounded-full">
                                    <!--  -->
                                    {{ user.type }}
                                    <!--  -->
                                  </div>
                                  <!--  -->
                                </div>
                                <!--  -->

                                <!--  -->
                                <div class="w-6 flex flex-col items-center">
                                  <!--  -->
                                  <button class="cursor-pointer w-6 h-6 text-black-500 outline-none focus:outline-none" @click="deleteItem('sellers', index)">
                                    <!--  -->
                                    <i class="material-icons">delete</i>
                                    <!--  -->
                                  </button>
                                  <!--  -->
                                </div>
                                <!--  -->
                              </div>
                              <!--  -->
                            </div>
                            <!--  -->
                          </div>
                          <!--  -->
                        </div>
                        <!--  -->
                      </div>
                      <!--  -->
                    </div>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->

            <!-- Select Products -->
            <div v-if="formData.country && formData.sellers" class="w-full">
              <!--  -->
              <div class="flex w-full space-x-6 h-full overflow-hidden">
                <!--  -->
                <div class="border mt-8 w-1/2 hover:border-orange-400 focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1">
                  <!--  -->
                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                    <!--  -->
                    <p>
                      <!--  -->
                      <label for="name" class="bg-white text-gray-700 px-1">
                        <!--  -->
                        Add Products to group
                        <!--  -->
                        <span :class="$colors.required"> *</span>
                        <!--  -->
                      </label>
                      <!--  -->
                    </p>
                    <!--  -->
                  </div>
                  <!--  -->

                  <!--  -->
                  <div class="md:w-full flex flex-col items-center p-1">
                    <!--  -->
                    <div class="w-full">
                      <!--  -->
                      <div class="flex flex-col items-center relative">
                        <!--  -->
                        <div class="w-full">
                          <!--  -->
                          <div class="mt-2 p-1 bg-white flex border border-gray-200 rounded">
                            <!--  -->
                            <div class="flex flex-auto flex-wrap"></div>
                            <!--  -->

                            <!--  -->
                            <input @input="searchProducts($event)" v-model="searchTextProduct" placeholder="Search Products" class="p-1 px-2 appearance-none outline-none w-full text-gray-800" />
                            <!--  -->

                            <!--  -->
                            <div class="text-gray-300 w-8 py-1 pl-2 pr-1 border-l flex items-center border-gray-200">
                              <!--  -->
                              <button class="cursor-pointer w-6 h-6 text-orange-500 outline-none focus:outline-none">
                                <!--  -->
                                <i class="material-icons">search</i>
                                <!--  -->
                              </button>
                              <!--  -->
                            </div>
                            <!--  -->
                          </div>
                          <!--  -->
                        </div>
                        <!--  -->

                        <!--  -->
                        <div class="bg-white mt-4 mb-2 max-h-select top-100 z-40 w-full rounded overflow-y-auto h-full">
                          <!--  -->
                          <div v-for="(product, index) in products" :key="index" :value="product._id" class="flex flex-col w-full">
                            <!--  -->
                            <div class="cursor-pointer bg-gray-100 dark:bg-dark-1 border-b border-gray-200 dark:border-dark-1 w-full  rounded-t hover:bg-teal-100">
                              <!--  -->
                              <div class="flex w-full items-center p-2 pl-2   relative hover:border-teal-100">
                                <!--  -->
                                <div class="w-6 flex flex-col items-center">
                                  <!--  -->
                                  <div class="flex relative w-6 h-6 justify-center items-center m-1">
                                    <!--  -->
                                    <img :alt="product.name" :src="product.picture || 'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg'" />
                                    <!--  -->
                                  </div>
                                  <!--  -->
                                </div>
                                <!--  -->

                                <!--  -->
                                <div class="w-full items-center flex">
                                  <!--  -->
                                  <div class="mx-2 mt-2">
                                    <!--  -->
                                    {{ product.name.length > 30 ? product.name.slice(0, 30) + '...' : product.name }}
                                    <!--  -->
                                    <div class="text-xs truncate w-full normal-case font-normal -mt-1 text-gray-500">
                                      <!--  -->
                                      {{ product.id }}
                                      <!--  -->
                                    </div>
                                    <!--  -->
                                  </div>
                                  <!--  -->
                                </div>
                                <!--  -->

                                <!--  -->
                                <div class="w-full items-center flex">
                                  <!--  -->
                                  <div class="text-sm text-center leading-5 text-orange-500 bg-orange-100 px-4 font-semibold rounded-full">
                                    <!--  -->
                                    product
                                    <!--  -->
                                  </div>
                                  <!--  -->
                                </div>
                                <!--  -->

                                <!--  -->
                                <div class="w-6 flex flex-col items-center">
                                  <!--  -->
                                  <button class="cursor-pointer w-6 h-6 text-black-500 outline-none focus:outline-none" @click="addItem('products', index)">
                                    <!--  -->
                                    <i class="material-icons">add</i>
                                    <!--  -->
                                  </button>
                                  <!--  -->
                                </div>
                                <!--  -->
                              </div>
                              <!--  -->
                            </div>
                            <!--  -->
                          </div>
                          <!--  -->
                        </div>
                        <!--  -->
                      </div>
                      <!--  -->
                    </div>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->

                <!-- Selected Sellers -->
                <div class="border mt-8 w-1/2 h-select hover:border-orange-400 focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1">
                  <!--  -->
                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                    <!--  -->
                    <p>
                      <!--  -->
                      <label for="name" class="bg-white text-gray-700 px-1">
                        <!--  -->
                        Selected Products
                        <!--  -->
                        <span :class="$colors.required"></span>
                        <!--  -->
                      </label>
                      <!--  -->
                    </p>
                    <!--  -->
                  </div>
                  <!--  -->

                  <!--  -->
                  <div class="md:w-full flex flex-col items-center h-64">
                    <!--  -->
                    <div class="flex items-center justify-center py-2" v-if="formData.products.length <= 0">
                      <!--  -->
                      <span class="w-full flex justify-center text-center py-20 border-gray-200 text-base">
                        <!--  -->
                        <p class="font-semibold flex text-orange-500 whitespace-no-wrap">
                          <!--  -->
                          <span class="">No product selected</span>
                          <!--  -->
                        </p>
                        <!--  -->
                      </span>
                      <!--  -->
                    </div>
                    <!--  -->

                    <!--  -->
                    <div class="w-full">
                      <!--  -->
                      <div class="flex flex-col items-center relative">
                        <!--  -->
                        <div class="absolute my-2 bg-white top-100 z-40 w-full lef-0 rounded min-h-select overflow-y-auto svelte-5uyqqj">
                          <!--  -->
                          <div v-for="(product, index) in formData.products" :key="index" :value="product._id" class="flex flex-col w-full">
                            <!--  -->
                            <div class="cursor-pointer bg-gray-100 dark:bg-dark-1 border-b border-gray-200 dark:border-dark-1 w-full  rounded-t  hover:bg-teal-100">
                              <!--  -->
                              <div class="flex w-full items-center p-2 pl-2  relative hover:border-teal-100">
                                <!--  -->
                                <div class="w-6 flex flex-col items-center">
                                  <!--  -->
                                  <div class="flex relative w-5 h-5 0 justify-center items-center m-1 mr-2 mt-1 rounded-full">
                                    <!--  -->
                                    <div class="w-6 flex flex-col items-center">
                                      <!--  -->
                                      <div class="flex relative w-6 h-6 justify-center items-center m-1">
                                        <!--  -->
                                        <img :alt="product.name" :src="product.picture || 'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg'" />
                                        <!--  -->
                                      </div>
                                      <!--  -->
                                    </div>
                                    <!--  -->
                                  </div>
                                  <!--  -->
                                </div>
                                <!--  -->

                                <!--  -->
                                <div class="w-full items-center flex">
                                  <!--  -->
                                  <div class="mx-2 -mt-1">
                                    <!--  -->
                                    {{ product.name.length > 30 ? product.name.slice(0, 30) + '...' : product.name }}
                                    <!--  -->
                                    <div class="text-xs truncate w-full normal-case font-normal -mt-1 text-gray-500">
                                      <!--  -->
                                      {{ product.id }}
                                      <!--  -->
                                    </div>
                                    <!--  -->
                                  </div>
                                  <!--  -->
                                </div>
                                <!--  -->

                                <!--  -->
                                <div class="w-full items-center flex">
                                  <!--  -->
                                  <div class="text-sm text-center leading-5 text-orange-500 bg-orange-100 px-4 font-semibold rounded-full">
                                    <!--  -->
                                    product
                                    <!--  -->
                                  </div>
                                  <!--  -->
                                </div>
                                <!--  -->

                                <!--  -->
                                <div class="w-6 flex flex-col items-center">
                                  <!--  -->
                                  <button class="cursor-pointer w-6 h-6 text-black-500 outline-none focus:outline-none" @click="deleteItem('products', index)">
                                    <!--  -->
                                    <i class="material-icons">delete</i>
                                    <!--  -->
                                  </button>
                                  <!--  -->
                                </div>
                                <!--  -->
                              </div>
                              <!--  -->
                            </div>
                            <!--  -->
                          </div>
                          <!--  -->
                        </div>
                        <!--  -->
                      </div>
                      <!--  -->
                    </div>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->

            <!-- Save -->
            <div class="mt-6 pt-3 flex justify-center">
              <!--  -->
              <button class="rounded focus:outline-none outline-none text-gray-100 px-3 w-1/6 py-2 bg-orange-500 hover:shadow-inner hover:bg-orange-700 transition-all duration-300" @click="save"> 
                Save
              </button>
              <!--  -->
            </div>
            <!-- Save -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->
    </div>
    <!--  -->
  </div>
  <!--  -->
</template>

<script>
export default {
  data() {
    return {
      formData: {
        name: "",
        country: null,
        description: "",
        sellers: [],
        products: [],
        teleConsultants: [],
        type: "",
        hisOrders: false,
        traitByOther: false
      },
      sellers: [],
      products: [],
      teleConsultants: [],
      listUser: [],
      listSellers: [],
      listTeleConsultants: [],
      roles: [],
      limit: 10,
      searchTextSeller: "",
      searchTextProduct: "",
      searchTextTeleConsultant: "",
      options: this.$countries,
      selectCountry: "",
      warehouse: null,
      warehouses: []
    };
  },
  async mounted() {
    await this.getWarehouses();
    await this.getSellersOrTeleCon("Seller");
    await this.getSellersOrTeleCon("TeleConsultant");
    await this.dataToEdit();
  },
  methods: {
    RouterBack: function () {
      this.$router.back();
    },
    async getWarehouses() {
      const filter = { limit: 1000 };
      const res = await this.$server.search("warehouses", filter);
      if (res.content.results) {
        let data = res.content.results;
        for (let i in data) {
          this.warehouses.push({
            id: data[i]._id,
            code: data[i].country,
            name: this.$f.getCountryNameByCode(this.options, data[i].country)
          })
        }
      } else this.warehouses = [];
    },
    async setSelectedCountry(country) {
      if (country) {
        this.formData.country = country.name;
        this.selectCountry = country.code;
        this.formData.sellers = [];
        this.formData.products =[];
        this.formData.teleConsultants = [];
        this.warehouse = await this.getwharhouse(country.code);
        await this.getSellersOrTeleCon("Seller");
        await this.getSellersOrTeleCon("TeleConsultant");
      }
    },
    async getwharhouse(country) {
      const resW = await this.$server.get("warehouses", { country: country });
      if (resW.content) return resW.content;
    },
    async getSellersOrTeleCon(type) {
      if (this.selectCountry) {
        const res = await this.$server.search("users", { 
          type: type, 
          countries: this.selectCountry,
          limit: 10
        });
        if (res.content.results) {
          if (type == "Seller") this.sellers = res.content.results;
          else this.teleConsultants = res.content.results;
        } else {
          if (type == "Seller") this.sellers = [];
          else this.teleConsultants = [];
        }
      }
    },
    async getProducts(sellersIds) {
      if(this.warehouse) {
        const filters = {
          seller: sellersIds,
          'details.warehouse': this.warehouse._id,
          limit: 10,
        };
        const res = await this.$server.search('products', filters);
        if (res.content.results) {
          this.products = res.content.results;
        } else this.products = [];
      }
    },
    searchSellersOrTeleCon: _.debounce(async function (search, type) {
      try {
        const filter = {
          type: type,
          limit: this.limit,
          countries: this.selectCountry,
          name: search.target.value,
        };

        const res = await this.$server.find("users", filter);
        const results = res.content.results || [];

        if (type === "Seller") {
          this.sellers = results;
        } else {
          this.teleConsultants = results;
        }
      } catch (error) {
        console.error("Error fetching users:", error);
        this.sellers = [];
        this.teleConsultants = [];
      }
    }, 500),
    searchProducts: _.debounce(async function (name) {
      try {
        const sellersIds = this.formData.sellers.map(seller => seller._id);
        if (sellersIds.length > 0) {
          const filter = { 
            seller: sellersIds,
            warehouse: this.warehouse._id,
            search: name.target.value, 
            notPopulate: true 
          };
  
          const products = await this.$store.dispatch('wharhouse/searchProducts', filter);
          this.products = products || [];
        } 
      } catch (error) {
        console.error("Error fetching products:", error);
        this.products = [];
      }
    }, 500),
    async save() {
      if (this.formData._id) {
        if (this.formData.sellers.length > 0 && this.formData.teleConsultants.length > 0 && this.formData.country) {
          if (this.checkData()) {
            this.formData.country = this.selectCountry;
            const data = await this.$server.update("teams", this.formData);
            if (data && data._id) {
              alert("team updated", "success");
            } else alert(data, "warning");
          } else {
            alert(`you must fill all the fields !! `, "warning");
          }
        } else {
          alert(`you must select members !! `, "warning");
        }
      } else {
        if (this.formData.sellers.length > 0 && this.formData.teleConsultants.length > 0 && this.formData.country) {
          if (this.checkData()) {
            this.formData.country = this.selectCountry;
            const data = await this.$server.create("teams", this.formData);
            if (data && data._id) {
              alert("team created", "success");
              this.products = [];
              this.formData = {
                name: "",
                warehouse: null,
                description: "",
                teleConsultants: [],
                sellers: [],
                products: [],
                type: "",
              }
            } else alert(data, "warning");
          } else {
            alert(`you must fill all the fields !! `, "warning");
          }
        } else {
          alert(`you must select members !! `, "warning");
        }
      }
    },
    checkData() {
      if (this.formData.name && this.formData.sellers && this.formData.teleConsultants) {
        return true;
      } else {
        return false;
      }
    },
    async dataToEdit() {
      if (this.$route.params.id) {
        const editData = await this.$server.get("teams", {
          id: this.$route.params.id,
        });
        this.formData = editData.content;
        this.warehouse = await this.getwharhouse(this.formData.country);
        this.selectCountry = this.formData.country;
        this.formData.country = this.$f.getCountryNameByCode(this.options, this.selectCountry);

        await this.updateProductsBasedOnSellers();
        await this.getSellersOrTeleCon("Seller");
        await this.getSellersOrTeleCon("TeleConsultant");
      }
    },
    async updateProductsBasedOnSellers() {
      const sellersIds = this.formData.sellers.map(seller => seller._id);
      if (sellersIds.length > 0) {
        await this.getProducts(sellersIds);
      } else {
        this.products = [];
      }
    },
    async addItem(type, index) {
      try {
        const item = this[type][index];
        const itemList = this.formData[type];

        const existingIndex = itemList.findIndex(o => o._id === item._id);

        if (existingIndex !== -1) {
          alert(`This ${type.slice(0, -1)} already exists in the group`, "warning");
          return;
        }

        itemList.push(item);

        if (type === 'sellers') {
          await this.updateProductsBasedOnSellers();
        }
      } catch (error) {
        console.error(`Error adding item to ${type}:`, error);
      }
    },
    async deleteItem(type, index) {
      try {
        const itemToRemove = this.formData[type][index];

        this.formData[type].splice(index, 1);

        if (type === 'sellers') {
          this.formData.products = this.formData.products.filter(product => product.seller !== itemToRemove._id);
          await this.updateProductsBasedOnSellers();
        }
      } catch (error) {
        console.error(`Error deleting item from ${type}:`, error);
      }
    }
  },
};
</script>

<style>
.top-100 {
  top: 100%;
}

.bottom-100 {
  bottom: 100%;
}

.max-h-select {
  max-height: 190px;
}

.min-h-select {
  max-height: 256px;
}

.h-select {
  height: 283px;
}

.border-users {
  border: 1px solid #efefef;
}
</style>
